import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notifications:any
  constructor(
    private api:ApiService ,private route: ActivatedRoute
  ) { 
    this.route.params.subscribe(params => {
      console.log(params['id']);
      let id = params['id'];
      if(id){
        this.getNotification(id);
      }
    });
  }

  ngOnInit(): void {

  }

 getNotification(id:any){
    this.api.Get('notifications').then(data=>{
      this.notifications = data['notifications'];
      this.notifications = this.notifications.filter((n:any) => n.id == id);
      console.log(this.notifications);
    }).catch(d=>{
      console.log(d);
    });
  }

}
